module.exports = __webpack_public_path__ + "static/media/equal-salary-second-baner.1f174065.png";